import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Townhouse } from 'src/app/models/Townhouse';


@Injectable({
    providedIn: 'root'
})
export class TownhouseApi extends Api<Townhouse> {}
